/* if you modify this file, please remove this line then fix eslint errors. */ /* eslint-disable */
import richContentService from '../../../Services/RichContent';

function userContent() {
  const userContentElements = document.querySelectorAll('.js-userContent');
  if (!userContentElements) {
    return;
  }

  [...userContentElements].forEach((userContentElement) => {
    [...userContentElement.querySelectorAll('table')].forEach((table) => {
      const wrapper = document.createElement('div');
      wrapper.classList.add('tableContainer');

      table.parentNode.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    });

    if (!userContentElement.hasAttribute('data-javascript-enabled')) {
      return;
    }
    richContentService({ container: userContentElement });
  });
}

export default userContent;
